import { render } from "./DashboardProductDetails.vue?vue&type=template&id=28a838e9"
import script from "./DashboardProductDetails.vue?vue&type=script&lang=js"
export * from "./DashboardProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__